var _rect, _rect2, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSmsTaskLight = function SvgSmsTaskLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#D0EED8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#328847"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 14.2C12.0267 14.2 12.2167 14.1233 12.37 13.97C12.5233 13.8167 12.6 13.6267 12.6 13.4C12.6 13.1733 12.5233 12.9833 12.37 12.83C12.2167 12.6767 12.0267 12.6 11.8 12.6C11.5733 12.6 11.3833 12.6767 11.23 12.83C11.0767 12.9833 11 13.1733 11 13.4C11 13.6267 11.0767 13.8167 11.23 13.97C11.3833 14.1233 11.5733 14.2 11.8 14.2ZM15 14.2C15.2267 14.2 15.4167 14.1233 15.57 13.97C15.7233 13.8167 15.8 13.6267 15.8 13.4C15.8 13.1733 15.7233 12.9833 15.57 12.83C15.4167 12.6767 15.2267 12.6 15 12.6C14.7733 12.6 14.5833 12.6767 14.43 12.83C14.2767 12.9833 14.2 13.1733 14.2 13.4C14.2 13.6267 14.2767 13.8167 14.43 13.97C14.5833 14.1233 14.7733 14.2 15 14.2ZM18.2 14.2C18.4267 14.2 18.6167 14.1233 18.77 13.97C18.9233 13.8167 19 13.6267 19 13.4C19 13.1733 18.9233 12.9833 18.77 12.83C18.6167 12.6767 18.4267 12.6 18.2 12.6C17.9733 12.6 17.7833 12.6767 17.63 12.83C17.4767 12.9833 17.4 13.1733 17.4 13.4C17.4 13.6267 17.4767 13.8167 17.63 13.97C17.7833 14.1233 17.9733 14.2 18.2 14.2ZM7 23V7H23V19.8H10.2L7 23ZM9.52 18.2H21.4V8.6H8.6V19.1L9.52 18.2Z",
    fill: "#328847"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmsTaskLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sms-task-light.50685806.svg";
export { ForwardRef as ReactComponent };